import { AxiosRequestConfig } from "axios";
import Repository, {
  ExtendedAxiosRequestConfig,
} from "@shared/services/api/abstracts/Repository";
import * as RepositoryUrlUtils from "@shared/services/api/utils/RepositoryUrlUtils";
import { UrlRouteMap } from "@shared/services/api/types";
import { VenueBasedVenueEmploymentAccessPIN } from "../types/serializer-types";

export default class VenueBasedAccessPinsRepository extends Repository<VenueBasedVenueEmploymentAccessPIN> {
  public readonly repositoryName = "VenueBasedAccessPinsRepository";

  public readonly endpoint = RepositoryUrlUtils.venueBasedUrl(
    "venues/employments/access-pins"
  );

  public get urlMap(): UrlRouteMap {
    return {
      ...this.defaultUrlMap,
      generate: "generate",
      deactivate: "deactivate",
      authorize: "authorize",
      revoke: "revoke",
    };
  }

  public async generate(
    data?: Partial<VenueBasedVenueEmploymentAccessPIN>,
    config: AxiosRequestConfig = {}
  ): Promise<VenueBasedVenueEmploymentAccessPIN> {
    const { data: response } = await this.request(this.buildUrl("generate"), {
      data,
      method: "post",
      ...config,
    });

    return response;
  }

  public async deactivate(
    data?: Partial<VenueBasedVenueEmploymentAccessPIN>,
    config: AxiosRequestConfig = {}
  ): Promise<VenueBasedVenueEmploymentAccessPIN> {
    const { data: response } = await this.request(this.buildUrl("deactivate"), {
      data,
      method: "post",
      ...config,
    });

    return response;
  }

  public async authorize(
    data?: Partial<VenueBasedVenueEmploymentAccessPIN>,
    config: ExtendedAxiosRequestConfig = {}
  ): Promise<VenueBasedVenueEmploymentAccessPIN> {
    const { data: response } = await this.request(this.buildUrl("authorize"), {
      data,
      method: "post",
      ...config,
    });

    return response;
  }

  public async revoke(
    config: ExtendedAxiosRequestConfig = {}
  ): Promise<VenueBasedVenueEmploymentAccessPIN> {
    const { data: response } = await this.request(this.buildUrl("revoke"), {
      method: "post",
      ...config,
    });

    return response;
  }
}
